import { Input, InputProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDebounce } from "@uidotdev/usehooks";

function DebouncedInput({
  value: initialValue,
  onDebouncedChange,
  placeholder,
  w
}: {
  value: string;
  onDebouncedChange: (value: string) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> & InputProps) {
  const [value, setValue] = useState<string>(initialValue);
  const debouncedValue = useDebounce<string>(value, 500)
  
  useEffect(() => {
    onDebouncedChange(debouncedValue)
  }, [debouncedValue])
  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholder}
      w={w}
    />
  );
}

export default DebouncedInput;
